import { Component, DestroyRef, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginState } from 'authentication/enums/login-state.enum';
import { filter } from 'rxjs';
import { TimerComponent } from 'shared/components/timer/timer.component';
import { AuthenticationService } from '../../services/authentication.service';
import { ToastService } from 'shared/services/toast.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss', '../../authentication.scss'],
    standalone: false,
})
export class LoginFormComponent implements OnDestroy {
    @ViewChild('timer') timerComponent!: TimerComponent;

    @Output() isLoggedIn = new EventEmitter<boolean>();

    public loginForm: FormGroup = new FormGroup<{
        email: FormControl<string>;
        password: FormControl<string>;
    }>({
        email: new FormControl<string>('', { validators: [Validators.required, Validators.email], nonNullable: true }),
        password: new FormControl<string>('', { validators: [Validators.required], nonNullable: true }),
    });
    public showPassword: boolean = false;
    public isOtpRequired: boolean = false;

    constructor(
        private authenticationService: AuthenticationService,
        private destroyRef: DestroyRef,
        private toastService: ToastService,
    ) {}

    public ngOnDestroy(): void {
        this.toastService.removeAll();
    }

    public login() {
        this.loginForm.markAllAsTouched();
        this.loginForm.get('email')?.updateValueAndValidity();
        this.loginForm.get('password')?.updateValueAndValidity();

        if (this.loginForm.valid) {
            this.authenticationService
                .login(this.loginForm.value)
                .pipe(
                    takeUntilDestroyed(this.destroyRef),
                    filter((response) => {
                        if (response === LoginState.TWO_FACTOR_AUTHENTICATION_ENFORCED) {
                            this.toastService.showToast({
                                body: 'generalKeywords.otp.emailSent',
                                severity: 'warning',
                                duration: 20000,
                                ignoreRemoval: true,
                            });

                            this.isOtpRequired = true;
                            return false;
                        }

                        return true;
                    }),
                )
                .subscribe((response) => this.isLoggedIn.emit(true));
        }
    }

    public onOtpSuccess() {
        this.isLoggedIn.emit(true);
    }

    public onCancelOtp() {
        this.isOtpRequired = false;
    }
}
